import PropTypes from 'prop-types';
import React from 'react';

const NoResultsRight = ({ className, width, height, ...otherProps }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 679.8 289.68"
    {...otherProps}
  >
    <defs>
      <style>
        {
          '.cls-1{isolation:isolate;}.cls-2{fill:#95cdf0;}.cls-3{fill:#0a3858;}.cls-4,.cls-7{fill:none;}.cls-4{stroke:#0a3858;stroke-linejoin:round;stroke-width:3px;}.cls-5{fill:#cb8c75;}.cls-6{fill:#729fbe;}.cls-7{stroke:#729fbe;stroke-miterlimit:10;}.cls-12,.cls-8{fill:#b28aa8;}.cls-9{fill:#470737;}.cls-10{fill:#f9af87;}.cls-11{fill:#048256;}.cls-12{mix-blend-mode:multiply;}.cls-13{fill:#096141;}'
        }
      </style>
    </defs>
    <g>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <polygon
            className="cls-2"
            points="465.09 154.17 452.88 196.05 455.6 218.98 443.33 221.01 436.73 175.71 465.09 154.17"
          />
          <path
            className="cls-3"
            d="M446.86,220.43l.82,5.73-9.75,4.94a1.44,1.44,0,0,0-.6,2h0a3.32,3.32,0,0,0,3.41,1.62l17.39-2.42-2.48-13.67Z"
          />
          <polyline
            className="cls-4"
            points="307.01 261.77 334.58 117.17 353.64 250.51"
          />
          <path
            className="cls-3"
            d="M419.57,224.63l-.07,5.05-10.38,5.26a2.84,2.84,0,0,0-1.19,4h0a3.71,3.71,0,0,0,3.81,1.81L431.13,238l-1.62-15.27Z"
          />
          <path
            className="cls-3"
            d="M264.11,266.67a21.73,21.73,0,0,1,9.09-15.75s-7.52,10.81-4.55,15.43Z"
          />
          <path
            className="cls-3"
            d="M258.27,269s-.79-22.4-28.69-27.91c0,0,24,9.83,22.8,33Z"
          />
          <path
            className="cls-3"
            d="M258.27,276.48s-4.32-20.44,2.36-31.25c0,0,.73,23.24,8,28.89Z"
          />
          <polygon
            className="cls-5"
            points="525.52 122.81 520.29 175.85 522.5 215.45 529.29 211.4 530.8 170.09 551.3 115.82 525.52 122.81"
          />
          <polygon
            className="cls-5"
            points="525.52 122.81 549.86 198.47 556.29 196.78 551.3 165.64 551.3 115.82 525.52 122.81"
          />
          <polygon
            className="cls-3"
            points="679.8 139.47 603.86 166.46 552.87 196.46 464.8 231.09 357.88 242.96 270.88 263.96 54.89 278.96 30.89 289.68 679.8 289.68 679.8 139.47"
          />
          <path
            className="cls-5"
            d="M522.5,59.68l-2.2-9-1.34.61.26-15.45-16.85,1.47v5.54a19.8,19.8,0,0,0,3,10.48h0a4.47,4.47,0,0,0,5.42,1.8l2.57-1L516.7,66.5Z"
          />
          <path
            className="cls-3"
            d="M512.52,42.4h0a4.68,4.68,0,0,0-4.64-4.93l-5.4,0v6a5.88,5.88,0,0,1-2.17-7.54c2.17-5,14.45-4.91,14.45-4.91a8.39,8.39,0,0,1,8.83,4.91l1.42,3.2a6.16,6.16,0,0,1-.16,5.32l-4.54,8.78-4.9-3.77h0A8.78,8.78,0,0,1,512.52,42.4Z"
          />
          <path
            className="cls-5"
            d="M502.45,42.7l-.87,5.39a.89.89,0,0,0,.88,1h1.1Z"
          />
          <path
            className="cls-8"
            d="M520.3,53.16s28.45,17.58,36.45,62.55l-31.22,7.1L515.41,68Z"
          />
          <path
            className="cls-3"
            d="M523.58,35.86s6.74,12.31,12.5,15C542.68,53.91,552,67.1,538.87,72L520.3,53.16Z"
          />
          <polygon
            className="cls-5"
            points="503.55 49.11 503.55 49.11 503.55 50.83 504.89 50.83 503.55 49.11"
          />
          <path
            className="cls-8 left-arm"
            d="M516.75,53.35l-18.61.57L473.8,48.37l-2.17,5.54,16.39,8a34.79,34.79,0,0,0,10,3.11l20,3,8.22-3.81-1.54-5.09A8.12,8.12,0,0,0,516.75,53.35Z"
          />
          <path
            className="cls-5 left-arm"
            d="M473.8,48.37l-3.94-2.92A12.68,12.68,0,0,0,463.57,43l-3.27-.33h0a1.75,1.75,0,0,0,1.25,1.67l3.88,1.16-.57,2.25A3.78,3.78,0,0,0,466,51.5h0a3.78,3.78,0,0,0,2.56,1h3.66Z"
          />
          <polygon
            className="cls-8"
            points="518.78 86.28 514.11 98.19 503.55 121.12 509.05 126.17 522.69 107.44 518.78 86.28"
          />
          <path
            className="cls-5"
            d="M506.2,123.55l-2.65-2.43-4.62,5L495.18,134h0a3.5,3.5,0,0,0,2.44-1.3l3.56-4.45a.76.76,0,0,1,.56-.29l.81,0a.76.76,0,0,1,.78.93l-.27,1.18-1.17,2.08h0a1.46,1.46,0,0,0,1.92-.73l1.58-3.44Z"
          />
          <polygon
            className="cls-9"
            points="525.52 122.81 520.29 170.98 563.63 165.64 556.74 115.71 525.52 122.81"
          />
          <path
            className="cls-3"
            d="M598.84,168.74s-.29-11.66-15.94-22c0,0,13.69,13.4,9.78,29.18S598.84,168.74,598.84,168.74Z"
          />
          <path
            className="cls-3"
            d="M597.84,168.74s-4.69-17.58,6.56-30.3c0,0-5.38,16.63,2.93,32.28Z"
          />
          <path
            className="cls-3"
            d="M602.1,173.17s-1.62-22,8.17-26.38c0,0-7.34,20.51,2.93,31.27Z"
          />
          <circle className="cls-3" cx="334.58" cy="116.56" r="8.44" />
          <path
            className="cls-3"
            d="M502.47,37.44s4,6.92,10.14,4.57l.23-5.89Z"
          />
          <rect
            className="cls-3"
            x="374.83"
            y="108.68"
            width="5.17"
            height="6.63"
            transform="matrix(0.97, 0.25, -0.25, 0.97, 40.71, -92)"
          />
          <rect
            className="cls-3"
            x="374.82"
            y="108.14"
            width="7.02"
            height="0.72"
            transform="translate(35.3 -84.47) rotate(13.36)"
          />
          <rect
            className="cls-3"
            x="267.09"
            y="86.23"
            width="2.5"
            height="18.91"
            transform="translate(33.22 -65.18) rotate(14.75)"
          />
          <path
            className="cls-2"
            d="M438.41,159.75,422,183.35a59.73,59.73,0,0,0-4.1,21.74v20L430.49,223l2.93-28.18,28.63-34c5.5-6.57,3.48-19.95,3.48-19.95Z"
          />
          <polygon
            className="cls-3"
            points="383.05 129.77 270.74 105.81 275.73 87.72 386.38 117.71 383.05 129.77"
          />
          <path
            className="cls-10"
            d="M366.77,122.74l-1.22-6.08a11.15,11.15,0,0,0-4.08-5.6,12.91,12.91,0,0,0-1.67-.77L356,109.13a.42.42,0,0,0-.5.6l2.46,4.57a6.8,6.8,0,0,1,.61,1.57l2.08,8.32Z"
          />
          <path
            className="cls-10"
            d="M407.93,110.36l-1.84-2.1L392.6,93.64l-12.73,10.19,7,10.06a7,7,0,0,0,.94,1.13,7.73,7.73,0,0,0,9.39,1l1.43-1.07a1.36,1.36,0,0,1,1.67,0l5.28,4.34Z"
          />
          <path
            className="cls-3"
            d="M399.37,102.06l-4.52.41L388.55,97l-8.68,6.89-1.66-.63a2.43,2.43,0,0,1-1.53-2.71h0a2.43,2.43,0,0,1,.62-1.23l4.84-5.19,4.2-3.37q.32-.26.66-.48a9.12,9.12,0,0,1,13,3.47l.23.42a9.28,9.28,0,0,1,.71,1.7L404,106l-2.13-1.86-2.55-2.12"
          />
          <path
            className="cls-10"
            d="M382.56,105.88l1.72,5.89a1,1,0,0,0,1.55.53l1.12-.75Z"
          />
          <path
            className="cls-11"
            d="M406.68,108.68s41.6,11.51,58.84,32.18l-30.16,23.29-36.53-34.38Z"
          />
          <path
            className="cls-11"
            d="M406.68,108.68l-26.94,28.11-13-14.05-6.13,1.46,11,17.92c4.07,5.52,13.09,6.32,18.17,1.72l21.43-19.4Z"
          />
          <polygon
            className="cls-10"
            points="385.15 109.47 386.39 114.39 388.19 113.29 385.15 109.47"
          />
          <circle
            className="cls-10"
            cx="397.11"
            cy="102.27"
            r="2.27"
            transform="translate(-7.68 36.72) rotate(-5.24)"
          />
          <polygon
            className="cls-12"
            points="515.41 68.01 521.44 68.49 516.21 71.76 515.41 68.01"
          />
          <polygon
            className="cls-12"
            points="520.29 96.12 520.29 110.72 522.69 107.44 520.29 96.12"
          />
          <polygon
            className="cls-6"
            points="462.05 160.81 439.71 196.14 438.61 188.63 462.05 160.81"
          />
          <polygon
            className="cls-13"
            points="407.53 127.75 404.04 134.68 401.75 132.98 407.53 127.75"
          />
          <path
            className="cls-10"
            d="M365.55,116.65l-1.47-.57-.69-4.43a.79.79,0,0,1,.57-1h0a.79.79,0,0,1,1,.57Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

NoResultsRight.propTypes = {
  className: PropTypes.string,
  width: PropTypes.node,
  height: PropTypes.node,
};

NoResultsRight.defaultProps = {
  height: 290,
  width: 680,
};

export default NoResultsRight;
